import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { FormControl, FormLabel } from "@/components/essentials/form-control";
import { Select } from "@/components/essentials/select";
import {
  selectContractorSameOrNewFormTestId,
  selectContractorSameOrNewFormSelectTestId,
  selectContractorSameOrNewFormLabelTestId,
  selectContractorSameOrNewOptions,
} from "./const";
import { type SelectContractorSameOrNewFormValue } from "./type";

export const SelectContractorSameOrNewForm: FC = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SelectContractorSameOrNewFormValue>();
  return (
    <FormControl
      id="selectContractorSameOrNewForm"
      isInvalid={errors.shippingAddressSameOrNew !== undefined}
      data-testid={selectContractorSameOrNewFormTestId}
    >
      <FormLabel data-testid={selectContractorSameOrNewFormLabelTestId}>お届け先住所</FormLabel>
      <Select
        data-testid={selectContractorSameOrNewFormSelectTestId}
        autoComplete="on"
        {...register("shippingAddressSameOrNew", { value: "same" })}
      >
        {selectContractorSameOrNewOptions.map(({ value, label }, key) => (
          <option key={key} value={value}>
            {label}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};
